var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 19.8718C10.3715 20.309 10.0138 20.6667 9.5766 20.6667H1.62788C1.1907 20.6667 0.833008 20.309 0.833008 19.8718V11.9231C0.833008 11.4859 1.1907 11.1282 1.62788 11.1282H9.5766C10.0138 11.1282 10.3715 11.4859 10.3715 11.9231V19.8718Z",
    fill: "#7B95AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 19.8718C21.4996 20.309 21.142 20.6667 20.7048 20.6667H12.7561C12.3189 20.6667 11.9612 20.309 11.9612 19.8718V11.9231C11.9612 11.4859 12.3189 11.1282 12.7561 11.1282H20.7048C21.142 11.1282 21.4996 11.4859 21.4996 11.9231V19.8718Z",
    fill: "#7B95AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7561 -1.04904e-05H20.7048C21.142 -1.04904e-05 21.4996 0.357682 21.4996 0.794862V8.74358C21.4996 9.18076 21.142 9.53845 20.7048 9.53845H12.7561C12.3189 9.53845 11.9612 9.18076 11.9612 8.74358V0.794862C11.9612 0.357682 12.3189 -1.04904e-05 12.7561 -1.04904e-05Z",
    fill: "#7B95AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5766 9.53845H1.62788C1.1907 9.53845 0.833008 9.18076 0.833008 8.74358V0.794862C0.833008 0.357682 1.1907 -1.04904e-05 1.62788 -1.04904e-05H9.5766C10.0138 -1.04904e-05 10.3715 0.357682 10.3715 0.794862V8.74358C10.3715 9.18076 10.0138 9.53845 9.5766 9.53845Z",
    fill: "#7B95AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/DashboardInactive.0c2f766b2aee3711cbbbdae1edb25ed3.svg";
export { ForwardRef as ReactComponent };